/* eslint-disable react/prop-types */
import { useEffect, useState, useRef } from 'react'
import { gsap } from 'gsap'
import { imgsUrl } from '../../constants'
import back from './assets/TEMPLATE-PROMOCAO.png'
import estrelas from './assets/estrelas.png'
import './style.scss'

const BTPPromoted = ({ news, cbFinished, interval }) => {
    const [finished, setFinished] = useState(false)
    const intervalo = useRef(interval * 1000)
    const timer = useRef(null)

    useEffect(() => {
        if (finished) {
            setFinished(false)
            cbFinished()
        }
    }, [cbFinished, finished])

    useEffect(() => {
        timer.current = window.setInterval(
            () => setFinished(true),
            intervalo.current,
        )
        return () => window.clearInterval(timer.current)
    }, [])

    useEffect(() => {
        const master = gsap.timeline({ defaults: { duration: 1 } })
        master.from('.congrats', { opacity: 0, y: '+50%' }, 1)
        // master.from('.nomFun', {opacity: 0})
        master.from('.carOri', { opacity: 0 })
        master.from('.carDes', { opacity: 0 })
    }, [])

    return (
        <div>
            <img className='back' src={back} alt='' />
            <img
                className='foto'
                src={`${imgsUrl}${news.fotEmp.fileName}`}
                alt=''
            />
            <img className='estrelas' src={estrelas} alt='' />
            <div className='textos'>
                <div className='nomFun'>{news.nomFun}</div>
                <div className='carOri'>CARGO ANTIGO: {`${news.carOri}`}</div>
                <div className='carDes'>CARGO NOVO: {`${news.carDes}`}</div>
            </div>
        </div>
    )
}

export default BTPPromoted
